import P5 from 'p5';
import * as opentype from 'opentype.js';
import {dataURItoBlob} from './data';

export const loadFont = function (p5: P5, path: string) {
  if (path.startsWith('data:')) {
    const p5Font = new P5.Font(p5);

    const blob = dataURItoBlob(path);
    const font = opentype.parse(blob);
    p5Font.font = font;

    return p5Font;
  }

  return p5.loadFont(path);
};